<fui-edit-fascia (clicked$)="click()" [disabled]="disabled" [focussed]="focussed" (focussed$)="focus()"
                 [hovered]="hovered">
    <fui-fixtures>
        <fui-fixture>
            <fui-input-label [disabled]="disabled" [focussed]="focussed" [hovered]="hovered"
                             [title]="label" [i18nParams]="labelI18NParams" [valued]="valued"></fui-input-label>
        </fui-fixture>
    </fui-fixtures>
    <fui-fixtures>
        <fui-fixture *ngIf="!disabled">
            <fui-mark-toggle [toggled]="popped">
                <fui-icon [height]="12" [icon]="'chevron-down'" [width]="12"></fui-icon>
            </fui-mark-toggle>
        </fui-fixture>
        <fui-spanning-fixture [ngClass]="{'checkered': !!value}">
            <fui-input-dom [style.background-color]="value">
                <input class="color-input"
                       #input [disabled]="disabled" (blur)="onBlur($event)" (focus)="onFocus($event)"
                       [(ngModel)]="value" [placeholder]="placeholder | translate" [readonly]="true"
                       [tabindex]="tabindex" type="text" [style.color]="textColor || (value | colorText)">
            </fui-input-dom>
        </fui-spanning-fixture>
        <fui-fixture *ngIf="showClearIcon">
            <fui-icon [height]="15" [width]="15" [icon]="'delete'"
                      [clickable]="true" (click)="clear($event)"></fui-icon>
        </fui-fixture>
        <fui-fixture *ngIf="validateable">
            <fui-validations [control]="control" [focussed]="focussed"></fui-validations>
        </fui-fixture>
    </fui-fixtures>
</fui-edit-fascia>
<fui-color-pop [popped]="popped" (popped$)="pop($event)">
    <div class="side-buffer" [ngClass]="{'popped': popped}">
        <div class="top-buffer">
        </div>
        <div *ngIf="translatedOkLabel && translatedResetLabel"
             #colorPicker
             [(colorPicker)]="color"
             [cpToggle]="true"
             [cpDialogDisplay]="'inline'"
             [cpCancelButton]="true"
             [cpCancelButtonText]="translatedResetLabel"
             [cpCancelButtonClass]="'color-action-button reset'"
             [cpOKButton]="true"
             [cpOKButtonText]="translatedOkLabel"
             [cpOKButtonClass]="'color-action-button ok'"
             [cpAlphaChannel]="allowAlpha ? 'always' : 'disabled'"
             [cpOutputFormat]="'hex'"
             (colorPickerSelect)="colorSelected($event)">
        </div>
    </div>
</fui-color-pop>
